import React, { ReactNode } from "react";
import * as styles from "./document-upload-preview.module.scss";
import { classArr } from "../helper/style-helper";

export interface DocumentUploadPreviewProps {
	className?: string;
	src: string | undefined;
	label: string;
	action?: ReactNode;
}

export default function DocumentUploadPreview(
	props: DocumentUploadPreviewProps,
) {
	return (
		<div className={classArr(props.className, styles.floorPreview)}>
			<img
				className={styles.floorPreviewImage}
				src={props.src}
				alt={props.label}
			/>

			<div className={styles.floorPreviewFile}>
				<span className={styles.floorPreviewFileName}>
					{props.label}
				</span>

				{props.action}
			</div>
		</div>
	);
}
